import { useI18n } from '@app-velocity/i18n';
import {
  Modal,
  Button,
  useModalWrapperContext,
  Typography,
} from '@app-velocity/ui';
import { useNotifications } from '@app-velocity/libs/notifications';

import { MyNotifications } from './components/MyNotifications';

export const NotificationsModalContent = () => {
  const { t } = useI18n();
  const { closeModal } = useModalWrapperContext();
  const { count } = useNotifications();

  return (
    <Modal>
      <Modal.Header title="users:notifications.title" />
      <Modal.Content>
        {count > 0 ? (
          <Typography>
            {t('users:notifications.pending')} <strong>{count}</strong>
          </Typography>
        ) : null}
        <MyNotifications />
      </Modal.Content>
      <Modal.Controls>
        <Button
          onClick={() => closeModal()}
          color="secondary"
          variant="contained"
        >
          {t('shared:close')}
        </Button>
      </Modal.Controls>
    </Modal>
  );
};
